export default function useActiveChatMetadata() {
    const formatMetadata = (entryMetadata: Array<{ name: string; value: string }>) => {
        if (!entryMetadata) {
            return;
        }

        return entryMetadata.map((metadata) => {
            if (!["from", "subject", "to", "cc", "bcc"].includes(metadata.name)) {
                return;
            }

            if (["from", "to", "cc", "bcc"].includes(metadata.name)) {
                const value = JSON.parse(metadata.value);

                return {
                    name: metadata.name,
                    value: value.name ? `${value.name} <${value.emailAddress}>` : `<${value.emailAddress}>`,
                };
            }

            return metadata;
        });
    };

    return {
        formatMetadata,
    };
}
